export default __webpack_public_path__ + "img/chevronLeft.c5f5b1bb.svg";